import { Link } from "react-router"

import CornerRibbon from "../../components/CornerRibbon"
import StripeSubmitButton from "../../components/StripeSubmitButton"
import SPBDynamicCheckoutCardItems from "./SPBDynamicCheckoutCardItems"
import WizardPaywallWidgetOption from "../../components/WizardPaywallWidgetOption"
import useMediaQuery from "../../hooks/useMediaQuery"
import { AccountRoleType } from "@/types/account"

export interface SPBDynamicCheckoutCardProps {
  role: AccountRoleType | undefined
  price: string
  handleStripeSubmit: () => void
}

const SPBDynamicCheckoutCard = ({
  role,
  price,
  handleStripeSubmit,
}: SPBDynamicCheckoutCardProps) => {
  const isMaxWidthMd = useMediaQuery("(max-width: 768px)")

  return (
    <WizardPaywallWidgetOption
      heading={
        <span className="flex flex-col">
          {isMaxWidthMd ? (
            <span className="bg-leaf text-white text-sm font-bold font-body leading-[150%] tracking-[0.14px] rounded-sm px-4 py-1 self-start mb-[10px]">
              Most Popular
            </span>
          ) : null}

          <span>NCX membership</span>
          <span className="block md:inline text-xl leading-[140%] tracking-[0.4px] mt-1 md:mt-0">
            {price}/month{" "}
            <span className="text-lg tracking-[0.36]">
              (yearly option available)
            </span>
          </span>
        </span>
      }
      subheading="Become an NCX Member to access tools and insights to help you decide, plan and take action on your land goals."
      subheadingClass="w-[calc(100%-50px)] text-lg font-body leading-[140%] tracking-[0.36px]"
      enabled={false}
      active={true}
      className="!cursor-auto"
    >
      {!isMaxWidthMd ? <CornerRibbon text="Most Popular" /> : null}

      <SPBDynamicCheckoutCardItems />

      <div className="flex flex-col items-center mt-2">
        <p className="text-charcoal-500 text-xs leading-[26px] tracking-[0.36px] mb-3">
          No long term contract. Cancel anytime.
        </p>

        <StripeSubmitButton
          role={role}
          text="Get Southern Pine Beetle Action Plan"
          trackingClass="spb-wizard member-widget-join-now"
          handleStripeSubmit={handleStripeSubmit}
        />

        <Link
          to="/"
          className="spb-wizard member-widget-dashboard-link inline-block text-lg text-leaf text-center font-bold leading-[140%] tracking-[0.36px] mt-3"
        >
          No thanks, bring me to my Dashboard
        </Link>
      </div>
    </WizardPaywallWidgetOption>
  )
}

export default SPBDynamicCheckoutCard
